/**
 * subtitleStyle WS → TranslationRecordView applyInit 纯函数（Web/H5 共用）
 */

import type { CrV3SessionSnapshot } from '../types'

/** 从 getSessionDataResult 快照提取 subtitleStyle */
export function subtitleStyleFromSession(
  session: Pick<CrV3SessionSnapshot, 'subtitleStyle'>,
): Record<string, unknown> | undefined {
  const style = session.subtitleStyle
  if (style && typeof style === 'object' && !Array.isArray(style)) {
    return style as Record<string, unknown>
  }
  return undefined
}

/** 解析 updateSubtitleStyle WS 消息 data */
export function subtitleStyleFromUpdateMessage(data: unknown): Record<string, unknown> | null {
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    return data as Record<string, unknown>
  }
  return null
}

/** Feed 层 applyInit 仅更新 subtitleStyle 的 payload */
export function buildSubtitleStyleApplyInit(style: Record<string, unknown>): {
  subtitleStyle: Record<string, unknown>
} {
  return { subtitleStyle: style }
}

/** useCrV3ViewerFeed / useCrV3H5Feed 的 onInit 中 subtitleStyle 字段 */
export function mergeInitSubtitleStyle(
  init: { subtitleStyle?: Record<string, unknown> | undefined },
): Record<string, unknown> | undefined {
  return init.subtitleStyle
}
